export function SaveCategory(this: any) {
  return {
    categoryName: this.categoryName,
    displayName: this.displayName,
    categoryGroup: this.categoryGroup,
    categoryGroupId: this.categoryGroupId,
    adapterName: this.adapterName,
    spName: this.sp,
    adapterType: this.adapterType,
    rPTAdapter: this.rptAdapters,
  };
}
